import "../../css/pages/caseStudiesDetailV2.scss";
import Tabs from "../modules/tabs";
import sectionNav from "../modules/sectionNav";

import BasePage from "./base";
import PageHero from "../modules/pageHero";

class CaseStudiesDetailV2Page extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
        new Tabs();
        new PageHero();
    }

    onReady() {
        super.onReady();
        sectionNav.init();
    }
}

new CaseStudiesDetailV2Page();
